import {v4 as uuidv4} from 'uuid';

export type StoredBft = {
  value: string;
};

export type BftResult = {
  bft: StoredBft;
  isNew: boolean;
};

export const getOrCreateBft = (id: string): BftResult => {
  const key = `bft-${id}`;
  const storedBft = localStorage.getItem(key);
  if (storedBft) {
    try {
      const parsed = JSON.parse(storedBft) as StoredBft;
      return {bft: parsed, isNew: false};
    } catch {
      // ignore parsing error, create a new one
    }
  }

  const newBft: StoredBft = {
    value: uuidv4(),
  };
  localStorage.setItem(key, JSON.stringify(newBft));
  return {bft: newBft, isNew: true};
};
